import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import SuperTableV2 from "../../SuperTableV2";
import CustomViews from "./CustomViews";
import Swal from "sweetalert2";
import { CustomViewsServices } from "./CustomViewsServices";

const ModalCustomViews = ({ show, setShow, setShowColumns, gantt , setViewName, rol }) => {
  const [views, setViews] = useState([]);

  const [showCreateView, setShowCreateView] = useState(false);
  const [viewToEdit, setViewToEdit] = useState("");
  const [selectView, setSelectView] = useState(
    window.localStorage.getItem("ViewName")
      ? window.localStorage.getItem("ViewName")
      : "Default"
  );
  const [idView, setIdView] = useState("")

  const handleUpdateView = async (IdView) => {
    setViewToEdit(views.filter((view) => view.IdVista == IdView));

    setShowCreateView(true);
  };

  const handleDeleteView = async (IdView) => {
    const nameView = views.filter((view) => view.IdVista == IdView)[0]
      .NombreVista;
    console.log(nameView);
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Al eliminar la vista: ${nameView}, quedara activa la vista predeterminada`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí,eliminar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        const result = await CustomViewsServices.deleteView(IdView);
        if (result.status === 200) {
          setViews((preViews) =>
            preViews.filter((view) => view.IdVista !== IdView)
          );

          Swal.fire(
            "¡Eliminado",
            "La vista ha sido eliminado exitosamente",
            "success"
          );
        }
      } catch (error) {
        Swal.fire("Error", error.message, "error");
      }
    }
  };

  const columns = [
    {
      caption: "Nombre",
      selector: "NombreVista",
      width: 300,
    },
    {
      caption: "Tipo",
      selector: "publica",
      width: 250,
      customRender: (row) => {
        console.log(row);
        const type = row.data.Publica ? "Pública" : "Privada";
        return <span>{type}</span>;
      },
    },
    {
      caption: "Editar",
      selector: "editar",
      customRender: (row) => {
        return (
          <Button
            variant="info"
            size="sm"
            onClick={() => handleUpdateView(row.data.IdVista)}
          >
            <i className="fa fa-edit"></i>
          </Button>
        );
      },
    },

    {
      caption: "Eliminar",
      selector: "eliminar",
      customRender: (row) => {
        return (
          <Button
            size="sm"
            onClick={() => handleDeleteView(row.data.IdVista)}
            disabled ={rol == 'Miembro de Equipo' ? true : false }
          >
            <i className="fa fa-trash"></i>
          </Button>
        );
      },
    },
  ];

  const loadViews = async () => {
    try {
      const result = await CustomViewsServices.getViewsByOrganzation();
      const defaultView = [
        { NombreVista: "Default", IdVista: null, Publica: true },
      ];

      setViews((prev) => {
        return [...defaultView, ...result];
      });
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    }
  };

  const handleChangeView = async (IdView) => { 

      const success = (viewName)=>{ 
        Swal.fire({
        title: `La Vista: ${viewName} ha sido activada correctamente`,
        icon: "success",
        draggable: true,
        confirmButtonColor: "#d33",
      });
      }

      if (IdView != "Default") {
        const nameView = views.filter((view) => view.IdVista == IdView)[0]
          .NombreVista;
        window.localStorage.setItem("ViewName", nameView);
        try {
          const result = await CustomViewsServices.getOneView(IdView);

          const itemsColumns = {};
          result[1].forEach((col) => {
            itemsColumns[col.NombreColumna] = [!col.Habilitada, col.Indice];
            return itemsColumns;
          });
          setSelectView(nameView);
          setShowColumns(itemsColumns);
          setViewName(nameView)
          success(nameView)
        } catch (error) {
          Swal.fire("Error", error, "error");
        }
      } else {
        window.localStorage.setItem("ViewName", "Default");
        setSelectView("Default");
        setShowColumns(CustomViewsServices.InitialStateColumns);
        setViewName("Default")
        success("Default")
      }
  };


  useEffect(() => {
    if(show){
      loadViews();
    }
  }, [show]);

  return (
    <>
      <Modal
        show={show}
        size="lg"
        backdrop="static"
        className={`${showCreateView ? "modal-custom-calendar" : ""}`}
      >
        <Modal.Header className="py-3 d-flex justify-content-between">
          <h5 className="mb-0">Vistas personalizadas</h5>
          <Button
            onClick={(e) => {
              setShow(false);
            }}
            variant="light"
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <p>
            Vista Actual : {/* <b> {calenderSelecter().nameCalendar} </b> */}{" "}
            <b>{selectView}</b>
          </p>
          <Form.Label>Seleccione Vista:</Form.Label>

          {views.length > 0 ? (
            <div className="d-flex" style={{gap:'10px'}}>
            <Form.Control
              size="sm"
              style={{
                borderColor: "#343a40",
                backgroundColor: "transparent",
                color: "#343a40",
                width: "350px",
              }}
              as="select"
              onChange={(e) => {
                if (e.target.value != 0) {
                  setIdView(e.target.value)
                }
              }}
            >
              <option value="0">Vistas disponibles...</option>
              {views?.map((view, idx) => {
                return (
                  <option key={idx} value={view.IdVista}>
                    {view.NombreVista}
                  </option>
                );
              })}

            </Form.Control>
              <Button
                onClick={()=>handleChangeView(idView)}
                className=""
                variant="success"
                size="sm"
              >
              Confirmar selección de vista
            </Button>
             </div>
          ) : (
            <>
              <br />
              <span>
                Aún no tienes vistas creadas. Estas usando la vista por defecto.
              </span>
            </>
          )}

          <div className="mt-4">
            <SuperTableV2
              data={views?.filter((view) => view.IdVista !== null)}
              columns={columns}
            />
          </div>
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                setShowCreateView(true);
              }}
              variant="success"
              size="sm"
            >
              Crear vista
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showCreateView} size="lg" backdrop="static">
        <Modal.Header className="py-3 d-flex justify-content-between">
          <h5 className="mb-0">Configurar vista personalizada</h5>
          <Button
            onClick={(e) => {
              setShowCreateView(false);
              setViewToEdit("");
            }}
            variant="light"
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <CustomViews
            setViews={setViews}
            setShowCreateView={setShowCreateView}
            viewToEdit={viewToEdit}
            show={showCreateView}
            setViewToEdit={setViewToEdit}
            gantt={gantt}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalCustomViews;
